import { ISVG } from "../UrlIcon";

export const HorizontalMiddleIcon = ({ className }: ISVG) => {
    return (
        <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className}`}>
            <path d="M.625 3.125h18.75a.625.625 0 1 0 0-1.25H.625a.625.625 0 1 0 0 1.25ZM3.438 6.875a.625.625 0 1 0 0 1.25h13.125a.625.625 0 0 0 0-1.25H3.438ZM19.375 11.875H.625a.625.625 0 1 0 0 1.25h18.75a.625.625 0 0 0 0-1.25ZM14.219 16.875H5.78a.625.625 0 1 0 0 1.25h8.438a.625.625 0 0 0 0-1.25Z" />
        </svg>
    );
};
